import React from "react";

export default function ResponsibleGaming() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-white md:mt-14">
      <h1 className="text-3xl font-bold mb-6 text-lime-400">
        🎯 Responsible Gaming – iqcage.com
      </h1>

      <p className="mb-4">
        At <strong>iqcage.com</strong>, we are committed to providing an
        exciting and safe gaming environment. While our games are designed for
        entertainment, we also take responsible gaming very seriously.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Our Commitment</h2>
      <ul className="list-disc ml-6 space-y-2">
        <li>We promote fair, transparent, and ethical gaming practices.</li>
        <li>
          We do not allow users under the age of 18 to play or make financial
          transactions.
        </li>
        <li>
          We encourage players to treat gaming as a form of entertainment — not
          a way to earn money or resolve financial issues.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Set Limits</h2>
      <p className="mb-4">
        You can choose to set daily, weekly, or monthly deposit limits in your
        account settings. This helps ensure that you stay in control of your
        gameplay and spending habits.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        Warning Signs of Problem Gaming
      </h2>
      <ul className="list-disc ml-6 space-y-2">
        <li>Spending more money or time than intended.</li>
        <li>Neglecting work, school, or relationships due to gaming.</li>
        <li>Chasing losses or feeling anxious when not playing.</li>
        <li>Using gaming as an escape from real-world problems.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Need Help?</h2>
      <p className="mb-4">
        If you feel that you or someone you know may have a gaming problem, we
        encourage you to seek help. Please contact a professional organization
        such as:
      </p>
      <ul className="list-disc ml-6 space-y-2">
        <li>
          <a
            href="https://www.begambleaware.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lime-400 underline"
          >
            BeGambleAware
          </a>
        </li>
        <li>
          <a
            href="https://www.gamblingtherapy.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lime-400 underline"
          >
            Gambling Therapy
          </a>
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">
        Account Self-Exclusion
      </h2>
      <p className="mb-4">
        Want a break? You can temporarily disable your account or request
        permanent exclusion by contacting our support team at{" "}
        <a href="mailto:support@iqcage.com" className="underline text-lime-400">
          support@iqcage.com
        </a>
        .
      </p>

      <p className="mt-8 text-sm text-slate-400">
        Last updated: {new Date().toLocaleDateString()}
      </p>
    </div>
  );
}
